var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 460 460",
    style: {
      enableBackground: "new 0 0 460 460"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1290_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1327_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2226_",
    style: {
      fill: "#3C5768"
    },
    d: "M385.482,193.785H26.793C11.996,193.785,0,181.79,0,166.993V126.75 c0-14.797,11.996-26.793,26.793-26.793h358.689c14.797,0,26.793,11.996,26.793,26.793v40.242 C412.275,181.79,400.279,193.785,385.482,193.785z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1342_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2225_",
    style: {
      fill: "#3C5768"
    },
    d: "M385.482,322.504H26.793C11.996,322.504,0,310.508,0,295.711v-40.242 c0-14.797,11.996-26.793,26.793-26.793h358.689c14.797,0,26.793,11.996,26.793,26.793v40.242 C412.275,310.508,400.279,322.504,385.482,322.504z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1343_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2224_",
    style: {
      fill: "#3C5768"
    },
    d: "M385.482,449.357H26.793C11.996,449.357,0,437.362,0,422.564v-40.242 c0-14.797,11.996-26.793,26.793-26.793h358.689c14.797,0,26.793,11.996,26.793,26.793v40.242 C412.275,437.362,400.279,449.357,385.482,449.357z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1344_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3068_",
    style: {
      fill: "#ECF0F1"
    },
    d: "M76.565,154.607H53.007c-4.272,0-7.735-3.463-7.735-7.735 s3.463-7.735,7.735-7.735h23.558c4.272,0,7.735,3.463,7.735,7.735S80.837,154.607,76.565,154.607z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1371_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3067_",
    style: {
      fill: "#ECF0F1"
    },
    d: "M76.565,283.325H53.007c-4.272,0-7.735-3.463-7.735-7.735 c0-4.272,3.463-7.735,7.735-7.735h23.558c4.272,0,7.735,3.463,7.735,7.735C84.301,279.862,80.837,283.325,76.565,283.325z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1372_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3066_",
    style: {
      fill: "#ECF0F1"
    },
    d: "M76.565,410.179H53.007c-4.272,0-7.735-3.463-7.735-7.735 c0-4.272,3.463-7.735,7.735-7.735h23.558c4.272,0,7.735,3.463,7.735,7.735C84.301,406.716,80.837,410.179,76.565,410.179z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_87_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2394_",
    style: {
      fill: "#F9B65F"
    },
    d: "M385.663,149.092v-46.553c0-27.4-22.212-49.612-49.612-49.612 c-27.4,0-49.612,22.212-49.612,49.612v46.553l-38.923,2.617V99.178c0-48.897,39.639-88.535,88.535-88.535 s88.535,39.639,88.535,88.535v52.531L385.663,149.092z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_89_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2223_",
    style: {
      fill: "#DE3E30"
    },
    d: "M430.063,279.881H242.038c-16.534,0-29.937-13.403-29.937-29.937V135.864H460 v114.081C460,266.478,446.597,279.881,430.063,279.881z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2268_",
    style: {
      opacity: 0.49,
      fill: "#D0D5D9"
    },
    d: "M426.329,135.864v91.059c0,17.052-13.824,30.876-30.876,30.876 H213.38c3.788,12.767,15.602,22.082,29.598,22.082h186.146c17.052,0,30.876-13.824,30.876-30.876V135.864H426.329z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3065_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M336.051,233.315c-4.272,0-7.735-3.463-7.735-7.735v-35.414 c0-4.272,3.463-7.735,7.735-7.735c4.272,0,7.735,3.463,7.735,7.735v35.414C343.786,229.851,340.323,233.315,336.051,233.315z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/Master.1310b7fdc5175df3a7ba26e8e0d9fe8a.svg";
export { ForwardRef as ReactComponent };